export const handleInvalidData = (val) => {
  return val === undefined || val === 'nan' ? '' : val;
};
